module.exports = __webpack_public_path__ + "img/offer.d1d1513b.png";